import React, { Component } from 'react'
import { Field } from 'redux-form'

import { Input } from 'components/Input/Input'
import Autosuggest from 'features/Autosuggest'
import { vRequired } from 'components/Input/Input.validations'

import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

const getComponent = (components, field, short) => {
  const item = components.find(comp => comp.types.includes(field))
  if (short) {
    return item && item.short_name ? item.short_name : ''
  }
  return item && item.long_name ? item.long_name : ''
}

export default class AddresField extends Component {
  static defaultProps = {
    addressName: 'address',
    postCodeName: 'postalCode',
    suburbName: 'suburb',
    stateName: 'state',
    countryName: 'country',
  }
  onLocationSelected = (event, { suggestion: { components } }) => {
    const { change, addressName, postCodeName, suburbName, stateName, countryName } = this.props
    change(suburbName, getComponent(components, 'locality'))
    change(postCodeName, getComponent(components, 'postal_code'))
    change(stateName, getComponent(components, 'administrative_area_level_1', true))
    change(countryName, 'Australia')
    const subpremise = getComponent(components, 'subpremise')
    const streetNum = getComponent(components, 'street_number')
    const route = getComponent(components, 'route')
    change(addressName, [subpremise ? `${subpremise}/` : '', `${streetNum} `, route].join(''))
  }
  render() {
    const {
      addressName,
      postCodeName,
      suburbName,
      stateName,
      countryName,
      hideCountry,
    } = this.props
    return (
      <div>
        <Field
          name={addressName}
          autosuggestType="location"
          component={Autosuggest}
          onSuggestionSelected={this.onLocationSelected}
          label="Street"
          validate={[vRequired]}
        />
        <Field name={suburbName} component={Input} label="Suburb" validate={[vRequired]} />
        <div className={sLay['layout-row']}>
          <div className={sLay.flex}>
            <Field name={stateName} component={Input} label="State" validate={[vRequired]} />
          </div>
          <div className={sLay.flex} style={{ paddingLeft: '10px' }}>
            <Field
              name={postCodeName}
              component={Input}
              type="number"
              label="Postcode"
              validate={[vRequired]}
            />
          </div>
        </div>
        {!hideCountry && <Field name={countryName} component={Input} label="Country" disabled />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Forms/Address/Address.jsx